import React from 'react';

const TipsTab = ({
  tips,
  categories,
  selectedCategory,
  setSelectedCategory,
  editingTip,
  setEditingTip,
  setShowAddTip,
  fetchTips,
  updateTip,
  deleteTip,
  isDarkMode
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <select 
            value={selectedCategory || ''} 
            onChange={(e) => { setSelectedCategory(e.target.value || null); }}
            className={`px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-800 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
          >
            <option value="">All Categories</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.name}>{cat.emoji} {cat.label}</option>
            ))}
          </select>
          <button onClick={fetchTips} className="px-3 py-2 bg-gray-200 dark:bg-gray-700 rounded-lg text-sm">🔄</button>
        </div>
        <button onClick={() => setShowAddTip(true)} className="px-4 py-2 bg-purple-600 text-white text-sm rounded-lg">
          + Add Tip
        </button>
      </div>

      {/* Tips List */}
      <div className="space-y-2">
        {tips.length === 0 ? (
          <div className={`text-center py-12 rounded-xl ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
            <p className="text-4xl mb-3">📚</p>
            <p className={isDarkMode ? 'text-gray-300' : 'text-gray-600'}>No tips yet</p>
            <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Click &quot;Initialize System&quot; to add sample tips</p>
          </div>
        ) : (
          tips.map(tip => {
            const cat = categories.find(c => c.name === tip.category);
            return (
              <div key={tip.id} className={`rounded-xl p-4 ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow`}>
                {editingTip?.id === tip.id ? (
                  <div className="space-y-3">
                    <select value={editingTip.category} onChange={(e) => setEditingTip(prev => ({...prev, category: e.target.value}))}
                      className={`w-full px-3 py-2 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}>
                      {categories.map(c => <option key={c.id} value={c.name}>{c.emoji} {c.label}</option>)}
                    </select>
                    <textarea value={editingTip.content} onChange={(e) => setEditingTip(prev => ({...prev, content: e.target.value}))}
                      className={`w-full px-3 py-2 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} rows={2} placeholder="Content" />
                    <input type="text" value={editingTip.translation || ''} onChange={(e) => setEditingTip(prev => ({...prev, translation: e.target.value}))}
                      className={`w-full px-3 py-2 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="Translation (if Darija)" />
                    <input type="text" value={editingTip.example || ''} onChange={(e) => setEditingTip(prev => ({...prev, example: e.target.value}))}
                      className={`w-full px-3 py-2 rounded border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`} placeholder="Example usage" />
                    <div className="flex gap-2">
                      <button onClick={() => updateTip(tip.id, editingTip)} className="px-3 py-1.5 bg-green-600 text-white text-sm rounded">Save</button>
                      <button onClick={() => setEditingTip(null)} className="px-3 py-1.5 bg-gray-500 text-white text-sm rounded">Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <span className={`px-2 py-0.5 rounded text-xs font-medium`} style={{backgroundColor: `var(--${cat?.color || 'gray'}-100)`, color: `var(--${cat?.color || 'gray'}-700)`}}>
                          {cat?.emoji || '📌'} {cat?.label || tip.category}
                        </span>
                      </div>
                      <p className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>{tip.content}</p>
                      {tip.translation && <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>= {tip.translation}</p>}
                      {tip.example && <p className={`text-sm ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`}>💡 {tip.example}</p>}
                    </div>
                    <div className="flex gap-1">
                      <button onClick={() => setEditingTip({...tip})} className="p-1.5 text-blue-500 hover:bg-blue-50 rounded">✏️</button>
                      <button onClick={() => deleteTip(tip.id)} className="p-1.5 text-red-500 hover:bg-red-50 rounded">🗑</button>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default TipsTab;
